import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ProposalService from '../../../services/ProposalService';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import Modal from '../../Modal';
import FormSelectedPayment from '../Action6/FormSelectedPayment';
import FormMotivoRecusa from './FormMotivoRecusa';
import AdditionalInformationComun from '../Action7/AdditionalInformationComun';
import HelperDate from '../../../helpers/HelperDate';
import { ViabilityChoice } from '../Viability';

interface IProp {
  proposal: any;
  statusActual: any;
}
const Action2 = ({ proposal, statusActual }: IProp) => {
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const navigate = useNavigate();

  function handleClick(aceito: boolean) {
    const product = proposal?.proposalType?.name ?? '';
    if (aceito) {
      if (product === "Solar Direct" || product === "Produtos" || product === "Serviços") {
        handleClickMetodPayment();
      } else {
        Modal.show({
          title: "Proposta",
          body: "Você realmente deseja aceitar?",
          showCancel: true,
          showConfirm: true,
          callBack: () => ProposalContract(true),
          cancelText: "Não",
          confirmText: "Sim"
        });
      }
    } else {
      Modal.show({
        title: "Contrato",
        body: <FormMotivoRecusa onConfirm={ProposalContract} />,
        showCancel: true,
        showConfirm: false // confirm agora será controlado dentro do form
      });
    }
  }

  function handleClickMetodPayment() {
    const product = proposal?.proposalType?.name ?? '';
    if (product !== "Solar Direct" && product !== "Produtos" && product !== "Serviços")
      return;

    Modal.show({
      title: "Aceite Proposta",
      body: <FormSelectedPayment proposal={proposal} statusActual={statusActual} ProposalContract={ProposalContract} />,
      showCancel: false,
      showConfirm: false,
      cancelText: "Não",
      confirmText: "Sim"
    });
  }

  function handleClickReviewProposal() {
    navigate(`/OpportunityReviewKit/${proposal.idProposalType}/${proposal.id}`);
  }

  function ProposalContract(aceito: boolean, motivo?: string | null, paymentMethodSave?: number | null, paymentConditionSave?: string | null, paymentObservation?: string | null, birthDate?: string | null, maritalStatus?: number | null, fullNameOfResponsible?: string | null, documentOfResponsible?: string | null) {
    const initialSolar = aceito && proposal?.proposalType?.name === 'Solar Direct' && statusActual?.proposalStatus?.name === 'Proposta Gerada';
    if (initialSolar) {
      Modal.show({ title: 'Tipo de Viabilidade', showCancel: true, showConfirm: false,
        body: <ViabilityChoice proposalId={proposal.id} onConfirm={async (viabilityType, viabilitySubmissionId) => {
          await ProposalService.postProposalContract({
            id: proposal.id, aceito, motivo: 0, paymentMethodSave, paymentConditionSave, paymentObservation,
            birthDate: birthDate ? HelperDate.convertFormatDate(birthDate, 'DD/MM/YYYY', 'YYYY-MM-DD') : null,
            maritalStatus, fullNameOfResponsible, documentOfResponsible, viabilityType, viabilitySubmissionId
          });
          navigate(0);
        }} />
      });
      return;
    }
    setIsLoad(true);
    const request = {
      id: proposal.id,
      aceito: aceito,
      motivo: aceito ? 0 : motivo || "0",
      paymentMethodSave,
      paymentConditionSave,
      paymentObservation,
      birthDate: birthDate ? HelperDate.convertFormatDate(birthDate ?? '', "DD/MM/YYYY", "YYYY-MM-DD") : null,
      maritalStatus: maritalStatus ?? null
    };
    ProposalService.postProposalContract(request)
      .then(() => {
        if(aceito && (proposal?.proposalType?.name ?? '') === 'Solar Direct'){
          setIsLoad(false);
          proposal.paymentType = paymentMethodSave;
          Modal.show({
            title: "Informações Adicionais",
            body: <AdditionalInformationComun proposal={proposal} isAccept={false} />,
            showCancel: true,
            showConfirm: false
          });
        }else{
          navigate(0)
        }
      })
      .catch((error) => {
        setIsLoad(false);
        Modal.show({
          title: "Erro ao enviar proposta",
          body: Modal.getErrorMessage(error, request),
          showCancel: true,
          showConfirm: false,
          onCancelText: "Fechar"
        });
      });
  }

  return (
    <>
      {isLoad && <LoadingSpinner />}
      {
        ((proposal.idProposalType === 1 || proposal.idProposalType === 2)
          && (statusActual.idProposalStatus === 6 || statusActual.idProposalStatus === 15))
          ? <>
            {
              proposal.proposalFile ?
                <a href={`${proposal.proposalFile}`} download target="_blank" style={{ marginBottom: 15 }} className='btn btn-outline-primary ms-auto' rel="noopener noreferrer">Abrir Proposta Readequada</a>
                : <p>- Sem arquivo de Readequação</p>
            }
          </>
          : <></>
      }
      {
        proposal.proposalFile &&
        <>
          {
            proposal.proposalFileValid
              ? 
              <>
              {
                 ((proposal.statusDiscount??0) === 1) 
                 ? <></>
                 : <button className='btn btn-primary btnForm d-block mt-2 minWidth200' onClick={() => handleClick(true)}>Aceito</button>
              }
              </>
              : 
              <>
              {
                ((proposal.statusDiscount??0) === 1)?
                <></> : <p style={{ color: 'red' }}>Sua proposta expirou, você deve fazer a revisão para atualizar sua proposta;</p>

              }
              </>
          }
        </>
      }
      {
        (proposal.idProposalType === 1) &&
        <>
          {
            (proposal.reviewDescription) &&
            <div className='alert alert-success'><i className='mdi mdi-alert-circle'></i> Solicitação de Revisão enviado!</div>
          }
          {
            ((proposal.statusDiscount??0) !== 1 ) &&
              <button className='btn btn-warning d-block mt-2 minWidth200' onClick={handleClickReviewProposal}>Revisar Proposta</button>
          }
        </>
      }
      <button className='btn btn-danger d-block mt-2 minWidth200' onClick={() => handleClick(false)}>Recusar Proposta</button>
    </>
  )
};

export default Action2;
